import React from 'react';
import classNames from 'classnames';

import { IconOutline, IconTypes } from '../../../types';

type IconUserProps = {
  variant?: 'user' | 'user-alt' | 'circle';
};

export const IconUser = ({
  className,
  width = 24,
  height = 24,
  variant = 'user',
  outline,
  ariaHidden = true,
  isClickable = false,
}: IconTypes & IconUserProps & IconOutline): React.ReactElement => {
  const defaultClass = classNames(
    'sui-fill-current',
    { 'sui-pointer-events-none': !isClickable },
    className
  );

  let iconVariant = outline ? (
    <path d="M12 12C14.2094 12 16 10.2094 16 8C16 5.79063 14.2094 4 12 4C9.79063 4 8 5.79063 8 8C8 10.2094 9.79063 12 12 12ZM14.8 13H14.2781C13.5844 13.3188 12.8125 13.5 12 13.5C11.1875 13.5 10.4188 13.3188 9.72188 13H9.2C6.88125 13 5 14.8813 5 17.2V18.5C5 19.3281 5.67188 20 6.5 20H17.5C18.3281 20 19 19.3281 19 18.5V17.2C19 14.8813 17.1187 13 14.8 13Z" />
  ) : (
    <path d="M14.8 13C13.9031 13 13.4719 13.5 12 13.5C10.5281 13.5 10.1 13 9.2 13C6.88125 13 5 14.8813 5 17.2V18.5C5 19.3281 5.67188 20 6.5 20H17.5C18.3281 20 19 19.3281 19 18.5V17.2C19 14.8813 17.1187 13 14.8 13ZM18 18.5C18 18.775 17.775 19 17.5 19H6.5C6.225 19 6 18.775 6 18.5V17.2C6 15.4344 7.43437 14 9.2 14C9.8125 14 10.4219 14.5 12 14.5C13.575 14.5 14.1875 14 14.8 14C16.5656 14 18 15.4344 18 17.2V18.5ZM12 12C14.2094 12 16 10.2094 16 8C16 5.79063 14.2094 4 12 4C9.79063 4 8 5.79063 8 8C8 10.2094 9.79063 12 12 12ZM12 5C13.6531 5 15 6.34687 15 8C15 9.65312 13.6531 11 12 11C10.3469 11 9 9.65312 9 8C9 6.34687 10.3469 5 12 5Z" />
  );

  if (variant === 'user-alt') {
    iconVariant = outline ? (
      <path d="M12 13C14.4844 13 16.5 10.9844 16.5 8.5C16.5 6.01562 14.4844 4 12 4C9.51562 4 7.5 6.01562 7.5 8.5C7.5 10.9844 9.51562 13 12 13ZM16 14H14.2781C13.5844 14.3188 12.8125 14.5 12 14.5C11.1875 14.5 10.4188 14.3188 9.72188 14H8C5.79063 14 4 15.7906 4 18V18.5C4 19.3281 4.67188 20 5.5 20H18.5C19.3281 20 20 19.3281 20 18.5V18C20 15.7906 18.2094 14 16 14Z" />
    ) : (
      <path d="M12 5C13.9312 5 15.5 6.56875 15.5 8.5C15.5 10.4313 13.9312 12 12 12C10.0687 12 8.5 10.4313 8.5 8.5C8.5 6.56875 10.0687 5 12 5ZM16 15C17.6531 15 19 16.3469 19 18V19H5V18C5 16.3469 6.34687 15 8 15C10.6562 15 10.1031 15.5 12 15.5C13.9031 15.5 13.3406 15 16 15ZM12 4C9.51562 4 7.5 6.01562 7.5 8.5C7.5 10.9844 9.51562 13 12 13C14.4844 13 16.5 10.9844 16.5 8.5C16.5 6.01562 14.4844 4 12 4ZM16 14C13.1125 14 13.7812 14.5 12 14.5C10.225 14.5 10.8844 14 8 14C5.79063 14 4 15.7906 4 18V19C4 19.5531 4.44687 20 5 20H19C19.5531 20 20 19.5531 20 19V18C20 15.7906 18.2094 14 16 14Z" />
    );
  }

  if (variant === 'circle') {
    iconVariant = outline ? (
      <path d="M12 4C7.58065 4 4 7.58065 4 12C4 16.4194 7.58065 20 12 20C16.4194 20 20 16.4194 20 12C20 7.58065 16.4194 4 12 4ZM12 7.09677C13.5677 7.09677 14.8387 8.36774 14.8387 9.93548C14.8387 11.5032 13.5677 12.7742 12 12.7742C10.4323 12.7742 9.16129 11.5032 9.16129 9.93548C9.16129 8.36774 10.4323 7.09677 12 7.09677ZM12 18.1935C10.1065 18.1935 8.40968 17.3355 7.27419 15.9935C7.88065 14.8516 9.06774 14.0645 10.4516 14.0645C10.529 14.0645 10.6065 14.0774 10.6806 14.1C11.1 14.2355 11.5387 14.3226 12 14.3226C12.4613 14.3226 12.9032 14.2355 13.3194 14.1C13.3935 14.0774 13.471 14.0645 13.5484 14.0645C14.9323 14.0645 16.1194 14.8516 16.7258 15.9935C15.5903 17.3355 13.8935 18.1935 12 18.1935Z" />
    ) : (
      <path d="M12 4C7.58065 4 4 7.58065 4 12C4 16.4194 7.58065 20 12 20C16.4194 20 20 16.4194 20 12C20 7.58065 16.4194 4 12 4ZM16.129 17.6C14.971 18.4548 13.5452 18.9677 12 18.9677C10.4548 18.9677 9.02903 18.4548 7.87097 17.6V17.1613C7.87097 16.0226 8.79677 15.0968 9.93548 15.0968C10.2935 15.0968 10.8226 15.4645 12 15.4645C13.1806 15.4645 13.7032 15.0968 14.0645 15.0968C15.2032 15.0968 16.129 16.0226 16.129 17.1613V17.6ZM17.1161 16.7129C16.8968 15.2161 15.6226 14.0645 14.0645 14.0645C13.4032 14.0645 13.0839 14.4323 12 14.4323C10.9161 14.4323 10.6 14.0645 9.93548 14.0645C8.37742 14.0645 7.10323 15.2161 6.88387 16.7129C5.73871 15.471 5.03226 13.8194 5.03226 12C5.03226 8.15806 8.15806 5.03226 12 5.03226C15.8419 5.03226 18.9677 8.15806 18.9677 12C18.9677 13.8194 18.2613 15.471 17.1161 16.7129ZM12 7.6129C10.4323 7.6129 9.16129 8.88387 9.16129 10.4516C9.16129 12.0194 10.4323 13.2903 12 13.2903C13.5677 13.2903 14.8387 12.0194 14.8387 10.4516C14.8387 8.88387 13.5677 7.6129 12 7.6129ZM12 12.2581C11.0032 12.2581 10.1935 11.4484 10.1935 10.4516C10.1935 9.45484 11.0032 8.64516 12 8.64516C12.9968 8.64516 13.8065 9.45484 13.8065 10.4516C13.8065 11.4484 12.9968 12.2581 12 12.2581Z" />
    );
  }
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={defaultClass}
      aria-hidden={ariaHidden}
    >
      {iconVariant}
    </svg>
  );
};
